function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["dataHelptip", "dataFor", "dataTip", "height", "width", "color", "isRequesting", "style", "children", "isCancel", "background", "disabled", "onClick", "variant", "sx"];
var _templateObject;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import { Button, CircularProgress } from '@mui/material';
import { red, grey } from '@mui/material/colors';
import { styled } from '@mui/material/styles';
import { GRAY, RED2, WHITE } from "../../colors";
var getButtonBackground = function getButtonBackground(_ref) {
  var background = _ref.background,
    isCancel = _ref.isCancel,
    disabled = _ref.disabled;
  if (background) {
    return background;
  }
  if (isCancel) {
    return GRAY;
  }
  if (disabled) {
    return red[900];
  }
  return red[500];
};
var StyledButton = styled(function (props) {
  var dataHelptip = props.dataHelptip,
    dataFor = props.dataFor,
    dataTip = props.dataTip,
    height = props.height,
    width = props.width,
    color = props.color,
    isRequesting = props.isRequesting,
    style = props.style,
    children = props.children,
    isCancel = props.isCancel,
    background = props.background,
    disabled = props.disabled,
    onClick = props.onClick,
    variant = props.variant,
    _props$sx = props.sx,
    sx = _props$sx === void 0 ? {} : _props$sx,
    others = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(Button, _extends({
    "data-helptip": dataHelptip,
    "data-tip": dataTip,
    "data-for": dataFor,
    role: "button",
    disabled: disabled,
    onClick: disabled ? null : onClick,
    sx: variant === 'outlined' ? [{
      textTransform: 'none',
      height: height || '40px',
      background: 'transparent',
      width: width || '100%',
      color: color || 'primary',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'secondary !important'
    }, {
      '&:hover': {
        background: RED2,
        color: WHITE,
        borderColor: 'transparent !important'
      },
      '&:disabled': {
        opacity: '25%'
      }
    }, _objectSpread({}, style), _objectSpread({}, sx)] : [{
      textTransform: 'none',
      height: height || '40px',
      background: getButtonBackground({
        isCancel: isCancel,
        background: background,
        disabled: disabled
      }),
      width: width || '100%',
      color: color || 'white'
    }, {
      '&:hover': {
        background: RED2,
        color: WHITE,
        borderColor: 'transparent !important'
      },
      '&:disabled': {
        backgroundColor: grey[400],
        color: WHITE
      }
    }, _objectSpread({}, style), _objectSpread({}, sx)]
  }, others), isRequesting ? /*#__PURE__*/React.createElement(CircularProgress, {
    color: variant === 'outlined' ? 'primary' : 'secondary',
    size: "30px",
    "aria-label": "loading-icon"
  }) : children);
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    hover: {\n        background: #b15e5d;\n        color: white;\n        border: none !important;\n    }\n"])));
var BrandButton = function BrandButton(props) {
  return /*#__PURE__*/React.createElement(StyledButton, props);
};
export default BrandButton;